import React, { useContext } from 'react';
import { MessageBar, MessageBarType, MessageBarButton } from '@fluentui/react';
import {
    CapabilityActionType,
    CapabilityDispatch,
} from '../../../Common/components/Capabilities/capabilityReducer';

export const NonAdminModeBanner: React.FC = () => {
    const capabilityDispatch = useContext(CapabilityDispatch);

    const nonAdminMode = JSON.parse(
        localStorage.getItem('nonAdminMode') ?? 'false'
    );

    if (!nonAdminMode) return null;

    return (
        <MessageBar
            messageBarType={MessageBarType.warning}
            isMultiline={false}
            actions={
                <div>
                    <MessageBarButton
                        onClick={() =>
                            capabilityDispatch({
                                type: CapabilityActionType.toggleNonAdminMode,
                            })
                        }
                    >
                        Exit non-admin mode
                    </MessageBarButton>
                </div>
            }
        >
            You are currently viewing the site in{' '}
            <strong>non-admin mode</strong>. Admin features are hidden.
        </MessageBar>
    );
};
